import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import logo183 from "../images/assets/logo183.jpg"
import logo184 from "../images/assets/logo184.webp"
import logo185 from "../images/assets/logo185.webp"
import logo186 from "../images/assets/logo186.webp"
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";

const Refer = () => {
  const navigate = useNavigate();

  const [is1, setIs1] = useState(false);
  const [is2, setIs2] = useState(false);
  const [is3, setIs3] = useState(false);
  const [is4, setIs4] = useState(false);
  const [is5, setIs5] = useState(false);
  const [is6, setIs6] = useState(false);
  const [is7, setIs7] = useState(false);
  const [is8, setIs8] = useState(false);
  const [is9, setIs9] = useState(false);
  const [is10, setIs10] = useState(false);
  const [is11, setIs11] = useState(false);
  const [is12, setIs12] = useState(false);
  const [is13, setIs13] = useState(false);
    const [showCopyLink, setShowCopyLink] = useState(false);
    const [copied, setCopied] = useState(false);
  
    const copyLink = () => {
        navigator.clipboard.writeText(window.location.href);
        setCopied(true);
        toast.success('Link copied!');
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };


  return (
    <div style={{ overflow: "hidden" }} >
      <div
  style={{
    backgroundImage: `url(${logo183})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "560px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "start",
    padding: "20px",
  }}
>
  <div className="referral-container">
    <h1 className="referral-heading">
      Spread The Word & <br />
      Earn Rewards upto ₹1000!
    </h1>
    <h6 className="referral-subheading">
      Invite your friends to unlock exciting rewards. That’s not all! <br />
      Get additional rewards when your friends place an order via your referral.
    </h6>
    {/* <Link>
      <button className="referral-button" onClick={() => navigate("/LoginModal")}>
        <small><b>SIGN UP TO GET REWARDED</b></small>
      </button>
    </Link> */}
  </div>
</div>

      <div style={{ width: 1550, fontFamily: "sans-serif", backgroundColor: "rgb(25, 177, 201)" }} className="d-flex justify-content-center py-sm-3 text-center"> 
    <div className="mt-5" style={{ fontFamily: "Crimson Text", color: "white" }}>
        <h2 style={{ fontSize: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            Zinger ERP Referral Program 
            <span style={{ marginLeft: "10px", cursor: "pointer" }} onClick={() => setShowCopyLink(!showCopyLink)}>
                <i className="bi bi-box-arrow-up" style={{ color: "black", fontSize: "30px" }}></i>
                {showCopyLink && (
                    <span style={{ fontSize: "16px", marginLeft: "5px", color: "black" }} onClick={(e) => { e.stopPropagation(); copyLink() }}>
                        Copy Link
                    </span>
                )}
            </span>
        </h2>
        <h6>The more you share, the more you earn!</h6>
        <span className="d-block border-bottom border-white mt-3 mb-5 mx-auto w-25"></span>
    </div>
</div>
      <div style={{
        backgroundColor: "rgb(25, 177, 201)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "560px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "between"
      }}>
        <div className="container d-flex justify-content-between">
          <div class="border-0">
            <img src={logo184} class="card-img-top rounded-3" />
            <div class="card-body text-center text-white">
              <h6 class="card-title mt-4"><b>1. Invite your friends</b></h6>
              <p class="card-text mt-2"> Share your referral link with your <br /> friends because sharing is caring! </p>
            </div>
          </div>
          <div class="border-0 top-10">
            <img src={logo185} class="card-img-top rounded-3" />
            <div class="card-body text-center text-white">
              <h6 class="card-title mt-4"><b>2. Earn sweet rewards</b></h6>
              <p class="card-text mt-2"> When your friend signs up using your <br />
                referral link, you earn up to ₹150. <br />
                Once they place an order, you get an <br />
                additional ₹950*
              </p>
            </div>
          </div>
          <div class="border-0">
            <img src={logo186} class="card-img-top rounded-3" />
            <div class="card-body text-center text-white">
              <h6 class="card-title mt-4"><b>3. Save on your next order</b></h6>
              <p class="card-text mt-2"> Redeem your rewards and save upto  <br /> ₹1000 on your next order </p>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: 1550, fontFamily: "sans-serif" }}
        className="d-flex justify-content-center py-sm-3 text-center">
        <div className="mt-5" style={{ fontFamily: "Crimson Text" }}>
          <h2 style={{ fontSize: "40px" }}>Frequently Asked Questions</h2>
          <h6>Your one-stop-solution to jewellery shopping and gifting round the year!</h6>
          <span className="d-block border-bottom border-info mt-3 mb-5 mx-auto w-25"> </span>
        </div>
      </div>
      <div className="container text-start w-50 h-100 position-relative" style={{
        border: "1px solid  #ccc", marginBottom: "5px",
        padding: "10px", borderRadius: "10px", fontFamily: "sans-serif"
      }} >
        <details className="container" open={is1} onClick={() => setIs1(!is1)} >
          <summary className="d-flex justify-content-between">
            <p>For how long is the referral link valid?</p>
            <ChevronDown className={`transition-transform duration-200 ${is1 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">There is no validity of the referral link.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is2} onClick={() => setIs2(!is2)} >
          <summary className="d-flex justify-content-between">
            <p>What can we buy using the referral amount?</p>
            <ChevronDown className={`transition-transform duration-200 ${is2 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">You can use your referral amount to purchase any jewellery product
            except Coins, Gifts, Frames, Bars and Pendants.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is3} onClick={() => setIs3(!is3)} >
          <summary className="d-flex justify-content-between ">
            <p>Can we encash or get the referral amount transferred to our bank account?</p>
            <ChevronDown className={`transition-transform duration-200 ${is3 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">No, encashment or transfer of referral amount is not allowed.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is4} onClick={() => setIs4(!is4)} >
          <summary className="d-flex justify-content-between ">
            <p>Can we avail of offers on the purchase that we make using the referral amount?</p>
            <ChevronDown className={`transition-transform duration-200 ${is4 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">Yes, the offers can be availed on your purchase.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is5} onClick={() => setIs5(!is5)} >
          <summary className="d-flex justify-content-between ">
            <p>How many referrals can we make using a single account?</p>
            <ChevronDown className={`transition-transform duration-200 ${is5 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">You can make 20 successful referrals from a single account.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is6} onClick={() => setIs6(!is6)} >
          <summary className="d-flex justify-content-between ">
            <p>What are the terms and conditions of using the referral amount?</p>
            <ChevronDown className={`transition-transform duration-200 ${is6 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">The terms & conditions of our referral module can be found in this link.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is7} onClick={() => setIs7(!is7)} >
          <summary className="d-flex justify-content-between ">
            <p>Can we pay our DGRP/Smart Jewellery Plan installment payments using the referral amount?</p>
            <ChevronDown className={`transition-transform duration-200 ${is7 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">Yes, the referral amount can be used to pay the installment amount
            of the DGRP Plan or Smart Jewellery Plan.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is8} onClick={() => setIs8(!is8)} >
          <summary className="d-flex justify-content-between ">
            <p>Does the referral amount get expired?</p>
            <ChevronDown className={`transition-transform duration-200 ${is8 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">Yes. The referral amount expires after 90 days from the date of credit.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is9} onClick={() => setIs9(!is9)} >
          <summary className="d-flex justify-content-between ">
            <p>Where can I check my successful referrals?</p>
            <ChevronDown className={`transition-transform duration-200 ${is9 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">You can check your successful referrals by visiting your ‘My Account’ section under
            Refer & Earn tab.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is10} onClick={() => setIs10(!is10)} >
          <summary className="d-flex justify-content-between ">
            <p>Can we buy a gift card using the referral amount?</p>
            <ChevronDown className={`transition-transform duration-200 ${is10 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">Buying a gift card using the referral amount is not allowed.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is11} onClick={() => setIs11(!is11)} >
          <summary className="d-flex justify-content-between ">
            <p>When is the referral amount reflected in my account?</p>
            <ChevronDown className={`transition-transform duration-200 ${is11 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">The referral amount is reflected 15 days after the order is
            delivered to the referee.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is12} onClick={() => setIs12(!is12)} >
          <summary className="d-flex justify-content-between ">
            <p>Is there any minimum price amount for the product?</p>
            <ChevronDown className={`transition-transform duration-200 ${is12 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">There is no minimum purchase cap for the products under this plan.</p>
        </details>
        <span className="d-block border-bottom border-1px solid  #585858 w-100"> </span>
        <details className="container" open={is13} onClick={() => setIs13(!is13)} >
          <summary className="d-flex justify-content-between">
            <p>Can we use the entire amount for one purchase?</p>
            <ChevronDown className={`transition-transform duration-200 ${is13 ? "rotate-180" : "rotate-0"}`} />
          </summary>  <p className="bg-light mt-1">Yes, your entire referral amount can be used to make one purchase.</p>
        </details>
      </div>
      <div className="text-center mb-5" onClick={() => navigate('/TermsConditions')}>
        <button style={{ border: "2px solid white ", color: " #585858", backgroundColor: "rgb(236, 241, 241)", width: "230px", marginTop: "50px", height: "60px", borderRadius: "10px", textAlign: "center", fontFamily: "sans-serif" }} onMouseEnter={(event) => (event.target.style.color = "black")} onMouseLeave={(event) => (event.target.style.color = " #585858")}>
          <small><b>VIEW TERMS & CONDITIONS</b></small>
        </button>
      </div>
      {/* <div className="container mb-5" style={{ fontFamily: "sans-serif" }}>
        <h5 className="mb-3">Popular Searches</h5>
        <h6><small>Zinger ERP  Collections</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-3">
          <small>Best Seller</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>New Arrival</small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Jewellery</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-3">
          <small>Diamond</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Platinum</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>New Arrival</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Diamond Jewellery for Women</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold Jewellery for Women</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Diamond Jewellery for Men</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold Jewellery for Men</small>
        </div>
        <span className="container mb-2" style={{
          display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
          marginTop: "10px"
        }}></span>
        <h6><small>Rings</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-3">
          <small>Engagement Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Diamond Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Solitaire Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Platinum Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Casual Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Classic Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Navratna Rings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gemstone Rings</small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Earrings</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2 ">
          <small> Solitaire Earrings</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Diamond Earrings   </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Solitaire Rings    </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold Earrings      </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Platinum Earrings  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Stud Earrings      </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Dangle Earrings    </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Sui Dhaga Earrings </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Navratna Earrings  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Jhumkas            </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Hoop Earrings      </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gemstone Earrings  </small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Necklace</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Diamond Necklace  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Platinum Necklace </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gemstone Necklace </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold Earrings     </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gold Necklace     </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Collar Necklace   </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Layered Necklace  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Pendant Necklace  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Charm Necklace    </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Delicate Necklace </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Lariat Necklace   </small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Bangles</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-3">
          <small>Kada</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Delicate Bangles</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Eternity Bangles</small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Bracelets</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Oval Bracelets  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Tennis Bracelets</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Chain Bracelets </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Flexi Bracelets </small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Solitaires</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Solitaire Rings     </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Solitaire Pendants  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Solitaire Nose Pins </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Earrings Solitaire  </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Necklace Solitaire  </small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Mangalsutra</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Solitaire Mangalsutra</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Mangalsutra Ring</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Mangalsutra with Chain</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Mangalsutra Bracelets</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Mangalsutra Chains</small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Pendants</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Initial Pendants   </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Solitaire Pendants </small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Pendants with Chain</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Casual Pendants    </small>
        </div>
        <span className="container mb-2" style={{ display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", marginTop: "10px" }}></span>
        <h6><small>Other Jewellery</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Peacock</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Chafa</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Butterfly</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Evil Eye</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Miracle Plate</small>
        </div>
        <span className="container mb-2" style={{
          display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
          marginTop: "10px"
        }}></span>
        <h6><small>Gifts</small></h6>
        <div style={{ color: "#585858", fontWeight: 300, fontSize: "13px" }} className="d-flex gap-2">
          <small>Anniversary Gifts</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Birthday Gifts</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gifts for Him</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gifts for Her</small>
          <span style={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}></span>
          <small>Gifts for Kids</small>
        </div>
        <span className="container mb-2" style={{
          display: "block", width: "2000px", borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
          marginTop: "10px"
        }}></span>
      </div> */}
    </div>
  )
}

export default Refer;